import React from 'react'
import { BANKING_BOTTOM_CONTENT, SOFTWARE_COURSE_PAGE_9, SOFTWARE_DETAILS_PAGE_9, SOFTWARE_HERO_PAGE_9 } from '../../../utils/constants'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'
import { SOFTWARE_ACCORDIAN_9 } from '../../../utils/courseConifg'

const SoftwarePage_9 = () => {
  return (
    <div className='outlet-render'>
          <CourseAsideHero  {...SOFTWARE_HERO_PAGE_9}/>
     <CoursesAside {...SOFTWARE_COURSE_PAGE_9}/>
     <CourseCard {...SOFTWARE_DETAILS_PAGE_9}/>
     <Accordian {...SOFTWARE_ACCORDIAN_9}/>
     <PageDesc {...BANKING_BOTTOM_CONTENT}/>
    </div>
  )
}

export default SoftwarePage_9